export default "__VITE_ASSET__C9TWgLMl__"